import "./actionList.scss";
import { Button } from "reactstrap";

const actionIcons = {
  preview: (
    <svg
      width={20}
      height={20}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 640 640"
    >
      <path
        fill="#495057"
        d="M480 272C480 317.9 465.1 360.3 440 394.7L566.6 521.4C579.1 533.9 579.1 554.2 566.6 566.7C554.1 579.2 533.8 579.2 521.3 566.7L394.7 440C360.3 465.1 317.9 480 272 480C157.1 480 64 386.9 64 272C64 157.1 157.1 64 272 64C386.9 64 480 157.1 480 272zM272 416C351.5 416 416 351.5 416 272C416 192.5 351.5 128 272 128C192.5 128 128 192.5 128 272C128 351.5 192.5 416 272 416z"
      />
    </svg>
  ),
  sendToReview: (
    <svg
      width={20}
      height={20}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 640 640"
    >
      <path
        fill="#F5BD58"
        d="M371.8 82.4C359.8 87.4 352 99 352 112L352 192L240 192C142.8 192 64 270.8 64 368C64 481.3 145.5 531.9 164.2 542.1C166.7 543.5 169.5 544 172.3 544C183.2 544 192 535.1 192 524.3C192 516.8 187.7 509.9 182.2 504.8C172.8 496 160 478.4 160 448.1C160 395.1 203 352.1 256 352.1L352 352.1L352 432.1C352 445 359.8 456.7 371.8 461.7C383.8 466.7 397.5 463.9 406.7 454.8L566.7 294.8C579.2 282.3 579.2 262 566.7 249.5L406.7 89.5C397.5 80.3 383.8 77.6 371.8 82.6z"
      />
    </svg>
  ),
  review: (
    <svg
      width={20}
      height={20}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 640 640"
    >
      <path
        fill="#F56E50"
        d="M224 224C224 171 267 128 320 128C373 128 416 171 416 224C416 266.7 388.1 302.9 349.5 315.4C321.1 324.6 288 350.7 288 392L288 416C288 433.7 302.3 448 320 448C337.7 448 352 433.7 352 416L352 392C352 390.3 352.6 387.9 355.5 384.7C358.5 381.4 363.4 378.2 369.2 376.3C433.5 355.6 480 295.3 480 224C480 135.6 408.4 64 320 64C231.6 64 160 135.6 160 224C160 241.7 174.3 256 192 256C209.7 256 224 241.7 224 224zM320 576C342.1 576 360 558.1 360 536C360 513.9 342.1 496 320 496C297.9 496 280 513.9 280 536C280 558.1 297.9 576 320 576z"
      />
    </svg>
  ),
  publish: (
    <svg
      width={20}
      height={20}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 640 640"
    >
      <path
        fill="#0576B9"
        d="M530.8 134.1C545.1 144.5 548.3 164.5 537.9 178.8L281.9 530.8C276.4 538.4 267.9 543.1 258.5 543.9C249.1 544.7 240 541.2 233.4 534.6L105.4 406.6C92.9 394.1 92.9 373.8 105.4 361.3C117.9 348.8 138.2 348.8 150.7 361.3L252.2 462.8L486.2 141.1C496.6 126.8 516.6 123.6 530.9 134z"
      />
    </svg>
  ),
  downloadPDF: (
    <svg
      width={18}
      height={20}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 640 640"
    >
      <path
        fill="#E83E8C"
        d="M128 64C92.7 64 64 92.7 64 128L64 512C64 547.3 92.7 576 128 576L208 576L208 464C208 428.7 236.7 400 272 400L448 400L448 234.5C448 217.5 441.3 201.2 429.3 189.2L322.7 82.7C310.7 70.7 294.5 64 277.5 64L128 64zM389.5 240L296 240C282.7 240 272 229.3 272 216L272 122.5L389.5 240zM272 444C261 444 252 453 252 464L252 592C252 603 261 612 272 612C283 612 292 603 292 592L292 564L304 564C337.1 564 364 537.1 364 504C364 470.9 337.1 444 304 444L272 444zM304 524L292 524L292 484L304 484C315 484 324 493 324 504C324 515 315 524 304 524zM400 444C389 444 380 453 380 464L380 592C380 603 389 612 400 612L432 612C460.7 612 484 588.7 484 560L484 496C484 467.3 460.7 444 432 444L400 444zM420 572L420 484L432 484C438.6 484 444 489.4 444 496L444 560C444 566.6 438.6 572 432 572L420 572zM508 464L508 592C508 603 517 612 528 612C539 612 548 603 548 592L548 548L576 548C587 548 596 539 596 528C596 517 587 508 576 508L548 508L548 484L576 484C587 484 596 475 596 464C596 453 587 444 576 444L528 444C517 444 508 453 508 464z"
      />
    </svg>
  ),
  downloadDOCX: (
    <svg
      width={18}
      height={20}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 640 640"
    >
      <path
        fill="#0576B9"
        d="M128 128C128 92.7 156.7 64 192 64L341.5 64C358.5 64 374.8 70.7 386.8 82.7L493.3 189.3C505.3 201.3 512 217.6 512 234.6L512 512C512 547.3 483.3 576 448 576L192 576C156.7 576 128 547.3 128 512L128 128zM336 122.5L336 216C336 229.3 346.7 240 360 240L453.5 240L336 122.5zM263.4 338.8C260.5 325.9 247.7 317.7 234.8 320.6C221.9 323.5 213.7 336.3 216.6 349.2L248.6 493.2C250.9 503.7 260 511.4 270.8 512C281.6 512.6 291.4 505.9 294.8 495.6L320 419.9L345.2 495.6C348.6 505.8 358.4 512.5 369.2 512C380 511.5 389.1 503.8 391.4 493.2L423.4 349.2C426.3 336.3 418.1 323.4 405.2 320.6C392.3 317.8 379.4 325.9 376.6 338.8L363.4 398.2L342.8 336.4C339.5 326.6 330.4 320 320 320C309.6 320 300.5 326.6 297.2 336.4L276.6 398.2L263.4 338.8z"
      />
    </svg>
  ),
  downloadDocumentCenter: (
    <svg
      width={20}
      height={20}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 640 640"
    >
      <path
        fill="#495057"
        d="M352 96C352 78.3 337.7 64 320 64C302.3 64 288 78.3 288 96L288 306.7L246.6 265.3C234.1 252.8 213.8 252.8 201.3 265.3C188.8 277.8 188.8 298.1 201.3 310.6L297.3 406.6C309.8 419.1 330.1 419.1 342.6 406.6L438.6 310.6C451.1 298.1 451.1 277.8 438.6 265.3C426.1 252.8 405.8 252.8 393.3 265.3L352 306.7L352 96zM160 384C124.7 384 96 412.7 96 448L96 480C96 515.3 124.7 544 160 544L480 544C515.3 544 544 515.3 544 480L544 448C544 412.7 515.3 384 480 384L433.1 384L376.5 440.6C345.3 471.8 294.6 471.8 263.4 440.6L206.9 384L160 384zM464 440C477.3 440 488 450.7 488 464C488 477.3 477.3 488 464 488C450.7 488 440 477.3 440 464C440 450.7 450.7 440 464 440z"
      />
    </svg>
  ),
};

const ActionList = ({
  id,
  status,
  title,
  onPreview,
  onSendToReview,
  onReview,
  onPublish,
  onDownloadPDF,
  onDownloadDOCX,
  onDownloadDocumentCenter,
  actions,
  variant,
}) => {

  const isApproved = status === "Approved";
  const canPublish = isApproved && actions.includes("publish") && variant !== "bulk";

  if (variant === "documentsCenter") {
    return (
      <div className="action-list action-list--document-center">
        <Button color="" className="action-list__action" onClick={(e) => onDownloadDocumentCenter(e, id)}>
          {actionIcons.downloadDocumentCenter} Download
        </Button>
      </div>
    );
  } else {
    return (
      <div className="action-list">
        {actions.includes("preview") && (
          <Button
            color=""
            className="action-list__action"
            onClick={(e) => onPreview(e, id, title)}
          >
            {actionIcons.preview}
          </Button>
        )}
        {(status === "Draft" && actions.includes("send_review")) && (variant !== "bulk") && (
          <>
            <Button
              color=""
              className="action-list__action"
              onClick={(e) => onSendToReview(e, id)}
            >
              {actionIcons.sendToReview}
            </Button>
          </>
        )}
        {status === "Review" && actions.includes("review") && (variant !== "bulk") && (
          <>
            <Button
              color=""
              className="action-list__action"
              onClick={(e) => onReview(e, id)}
            >
              {actionIcons.review}
            </Button>
          </>
        )}
        {isApproved && (
          <>
            {canPublish && (
              <Button
                color=""
                className="action-list__action"
                onClick={(e) => onPublish(e, id)}
              >
                {actionIcons.publish}
              </Button>
            )}

            <Button
              color=""
              className="action-list__action"
              onClick={(e) => onDownloadPDF(e, id)}
            >
              {actionIcons.downloadPDF}
            </Button>

            <Button
              color=""
              className="action-list__action"
              onClick={(e) => onDownloadDOCX(e, id)}
            >
              {actionIcons.downloadDOCX}
            </Button>
          </>
        )

        }
        {status === "Published" && actions.includes("download") && (
          <>
            <Button
              color=""
              className="action-list__action"
              onClick={(e) => onDownloadPDF(e, id)}
            >
              {actionIcons.downloadPDF}
            </Button>
            <Button
              color=""
              className="action-list__action"
              onClick={(e) => onDownloadDOCX(e, id)}
            >
              {actionIcons.downloadDOCX}
            </Button>
          </>
        )}
      </div>
    );
  }
};

export default ActionList;
